export const localRouter_meun_xd = [  //产业信贷大脑导航栏顺序
//域内招商 园区招商全部楼宇 全部企业 为新增页面 默认为true
{
    code: "A",
    switch: true,
    name: "本地企业",
    oldtext: "本地企业",
    type: "ynzs",
    url: "/allBuildings",
    open: true,
    icontype: "el-icon-menu",
    children: [{
            code: "A-QBLY",
            switch: true,
            name: "",
            oldtext: "全部楼宇",
            url: "/allBuildings"
        },
        {
            code: "A-QBQY",
            switch: true,
            name: "",
            oldtext: "全部企业",
            url: "/allEnterprises"
        },
        // {
        //     code: "A-ZSDT",
        //     switch: false,
        //     name: "",
        //     oldtext: "数字地图",
        //     url: "/enterprise-mapsearch"
        // },
    ]
},
//产业招商
{
    code: "A",
    switch: false,
    name: "",
    oldtext: "全国精选企业",
    type: "cyzs",
    url: "/enterpriseList?type=9&Pt=1",
    open: true,
    morebtn: false,
    icontype: "el-icon-menu",
    children: [{
            code: "A-LTQY",
            switch: true,
            name: "",
            oldtext: "龙头企业库",
            url: "/enterpriseList?type=9&Pt=1"
        },
        {
            code: "A-KCQY",
            switch: true,
            name: "",
            oldtext: "科创企业库",
            url: "/enterpriseList?type=2&Pt=2"
        },
        {
            code: "A-QBNZQY",
            switch: false,
            name: "",
            oldtext: "全部内资企业",
            url: "/totalEnterprises"
        },
        {
            code: "A-JWSSQY",
            switch: false,
            name: "",
            oldtext: "境外上市企业",
            url: "/foreignEnterprises"
        },
        {
            code: "A-WZQY",
            switch: true,
            name: "",
            oldtext: "外资企业库",
            url: "/forcapEnterprise"
        },
        {
            code: "A-TZJG",
            switch: false,
            name: "",
            oldtext: "投资机构",
            url: "/investment-institutions"
        },
    ]
},
//产业研究
{
    code: "B",
    switch: false,
    name: "",
    oldtext: "产业研究",
    url: "/allchain",
    open: true,
    morebtn: false,
    icontype: "el-icon-s-order",
    children: [{
            code: "B-QGTP",
            switch: false,
            name: "",
            oldtext: "全国图谱",
            url: "/allchain"
        },
        {
            code: "B-DDTP",
            switch: false,
            name: "",
            oldtext: "当地图谱",
            url: "/localChainList",
        },
        {
            code: "B-TZXMK",
            switch: false,
            name: "",
            oldtext: "投资项目库",
            url: "invest"
        },
        {
            code: "B-NDXMK",
            switch: false,
            name: "",
            oldtext: "拿地项目库",
            url: "land"
        },
        {
            code: "B-YJBGK",
            switch: false,
            name: "",
            oldtext: "研究报告库",
            url: "report",
            // newType: "VIP"
        },
        {
            code: "B-DTJC",
            switch: false,
            name: "",
            oldtext: "动态监测",
            url: "/investdynamic"
        },
        {
            code: "B-CYSJK",
            switch: true,
            name: "产业数据库",
            oldtext: "产业数据库",
            url: "/industryLibrary",
            newType:"NEW"
        },
        {
            code: "B-HYJHK",
            switch: true,
            name: "行业机会库",
            oldtext: "行业机会库",
            url: "/trade",
        },
        {
            code: "T-CXQYRZ",
            switch: true,
            name: "",
            oldtext: "企业投资动态报告",
            url: "freeReport",
            reportId: 10006, 
        },
        {code:"T-CXQYRZ",switch:true,name:"",oldtext:"产业投资动态跟踪月报",url:"reportList",reportId:10055},
    ]
},
{
    code: "J",
    switch: false,
    name: "",
    oldtext: "本地投资趋势",
    url: "/localInvestAnalysis?type=1",
    open: true,
    morebtn: false,
    icontype: "el-icon-s-order",
    children: [{
            code: "J-BSXZTZFX",
            switch: true,
            name: "",
            oldtext: "本省新增投资分析",
            url: "/localInvestAnalysis?type=1",
            // newType: "New",
        },
        {
            code: "J-BS-XZTZFX",
            switch: true,
            name: "",
            oldtext: "本市新增投资分析",
            url: "/localInvestAnalysis?type=2",
            // newType: "New",
        },
    ]
},
//智能推荐 以商招商线索——产业链金融  资本招商线索——投贷联动融资线索  企业投资窗口——企业投资（融资）窗口期  产业投资窗口——产业投资（融资）窗口期  热点产业重点企业线索——风口产业的重点企业
// 优质上市公司招商线索——优质上市公司筛选器  排行榜线索——企业投资排行榜 
{
    code: "C",
    switch: false,
    name: "",
    oldtext: "智能推荐",
    url: "/investment-clues2",
    open: true,
    morebtn: false,
    icontype: "el-icon-s-opportunity",
    children: [
        // {code:"C-CYLZSXS",switch:false,name:"",oldtext:"产业链招商",url:"/recommendation"},
        {
            code: "C-YSZSXS",
            switch: false,
            name: "",
            oldtext: "产业链金融",
            url: "/investment-clues2"
        },
        {
            code: "C-ZBZSXS",
            switch: false,
            name: "",
            oldtext: "投贷联动融资线索",
            url: "/investment-clues3"
        },
        {
            code: "C-QYTZCK",
            switch: false,
            name: "",
            oldtext: "企业投资（融资）窗口期",
            url: "/enterpriseInvestmentWindow",
        },  
        {
            code: "C-CYTZCK",
            switch: false,
            name: "",
            oldtext: "产业投资（融资）窗口期",
            url: "/industryInvestmentWindow",
        },
        {
            code: "C-GDXSTJ",
            switch: false,
            name: "",
            oldtext: "更多线索推荐",
            url: "/investment-clues1"
        },
    ]
},
//关系计算器
{
    code: "E",
    switch: false,
    name: "",
    oldtext: "关系计算器",
    url: "/enterprisesCityRelation",
    open: true,
    morebtn: false,
    icontype: "el-icon-s-platform",
    children: [{
            code: "E-QY－CSGXJSQ",
            switch: false,
            name: "",
            oldtext: "企业-城市 关系计算器",
            url: "/enterprisesCityRelation",
            newType: "HOT",
        },
        {
            code: "E-GXJSQ",
            switch: false,
            name: "",
            oldtext: "企业-企业 关系计算器",
            url: "/relationalcalculator"
        },


        {
            code: "E-WDGXW",
            switch: false,
            name: "",
            oldtext: "我的关系网",
            url: "/userrelational"
        },
    ]
},
//工作台
{
    code: "E",
    switch: false,
    name: "",
    oldtext: "工作台",
    url: "/workbench",
    open: true,
    morebtn: false,
    icontype: "el-icon-s-cooperation",
    children: [{
            code: "E-MBQY",
            switch: false,
            name: "",
            oldtext: "目标企业",
            url: "/focusenterprises"
        },
        {
                code: "E-DBQY",
                switch: true,
                name: "",
                oldtext: "企业对比",
                url: "/enterprise-compare",
                newType:'NEW',
            },
        {
            code: "E-ZZDT",
            switch: false,
            name: "",
            oldtext: "作战地图",
            url: "/targetMap",
        },
    ]
},
//个人中心
{
    code: "F",
    switch: false,
    name: "",
    oldtext: "个人中心",
    url: "/baseInformation",
    open: true,
    openicon: true,
    morebtn: false,
    icontype: "el-icon-s-custom",
    children: [{
            code: "F-JBZL",
            switch: true,
            name: "",
            oldtext: "基本资料",
            url: "/baseInformation"
        },
        {
            code: "F-MMXG",
            switch: true,
            name: "",
            oldtext: "密码修改",
            url: "/editPassword"
        },
        {
            code: "F-TCZH",
            switch: true,
            name: "",
            oldtext: "退出账号",
            url: "loginout"
        },
    ]
},
]